import { render } from "./Works.vue?vue&type=template&id=31c83674&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=31c83674&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c83674"]])

export default __exports__